import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';

import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../constants/routes';
import { usesOrganizationPermissions } from '../utils/orgPermissionAccess';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, sessionRefreshing, user, activeOrganization } = useAuth();
  const location = useLocation();
  const waitingForOrgPermissions =
    sessionRefreshing
    && usesOrganizationPermissions(user)
    && Boolean(activeOrganization?.id)
    && !user?.organization_permissions?.length;

  if (loading || waitingForOrgPermissions) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
